import { jsx as _jsx } from "react/jsx-runtime";
import { useLazyQuery } from '@apollo/client';
import { Autocomplete } from '@guildeducationinc/recess';
import { MACROS } from '@src/graphql/queries/macro';
import { useLocale } from 'pe-core-frontend';
import { useState } from 'react';
import styles from './MacroPicker.module.scss';
/**
 * MacroPicker component allows users to search and select macros.
 *
 * @param {Object} props - The component props.
 * @param {string} props.clientId - The client ID used for fetching macros.
 * @param {Function} props.onSelect - Callback function to handle the selection of a macro.
 * @param {boolean} [props.hideLabel] - Optional flag to hide the label.
 *
 * @returns {JSX.Element} The rendered MacroPicker component.
 */
export const MacroPicker = ({ clientId, onSelect, hideLabel }) => {
    const { t } = useLocale();
    const [selectedMacro, setSelectedMacro] = useState(null);
    const [fetchMacros] = useLazyQuery(MACROS);
    const handleChange = (e) => {
        if (e.selection === null) {
            onSelect(null);
            setSelectedMacro(null);
            return;
        }
        const macro = e.selection.macro;
        onSelect(macro);
        setSelectedMacro(e.selection);
    };
    const handleLoad = async (query, callback) => {
        const result = await fetchMacros({
            variables: { spec: { clientId, searchText: query, pagination: { page: 1, pageSize: 100 } } },
        });
        if (result.data === undefined) {
            callback([]);
            return;
        }
        const matches = result.data.macros?.items?.map((item) => ({
            value: item.id,
            label: item.title,
            macro: item,
        }));
        callback(matches);
    };
    return (_jsx("div", { className: styles.container, children: _jsx(Autocomplete, { label: t('Search Responses'), hideLabel: hideLabel, loadOptions: handleLoad, defaultOptions: true, value: selectedMacro, onChange: handleChange }) }));
};
